import { IAppState, TActions } from '../../../common/state';

export const IMinHouseYearChangedActionType = 'filters/house_year/MIN_HOUSE_YEAR_CHANGED';
export const IMaxHouseYearChangedActionType = 'filters/house_year/MAX_HOUSE_YEAR_CHANGED';

export interface IMinHouseYearChangedAction {
  type: 'filters/house_year/MIN_HOUSE_YEAR_CHANGED';
  value: number | undefined;
}

export interface IMaxHouseYearChangedAction {
  type: 'filters/house_year/MAX_HOUSE_YEAR_CHANGED';
  value: number | undefined;
}

export function changeMinHouseYear(value: number | undefined): IMinHouseYearChangedAction {
  return {
    type: IMinHouseYearChangedActionType,
    value,
  };
}

export function changeMaxHouseYear(value: number | undefined): IMaxHouseYearChangedAction {
  return {
    type: IMaxHouseYearChangedActionType,
    value,
  };
}

export function houseYearReducer(state: IAppState, action: TActions): IAppState {
  const house_year = state.filters.jsonQuery.house_year;

  switch (action.type) {
    case IMinHouseYearChangedActionType:
      return {
        ...state,
        filters: {
          ...state.filters,
          jsonQuery: {
            ...state.filters.jsonQuery,
            house_year:
              action.value !== undefined || (house_year && house_year.value.lte !== undefined)
                ? {
                    type: 'range',
                    value: {
                      gte: action.value,
                      lte: house_year && house_year.value.lte,
                    },
                  }
                : undefined,
          },
        },
      };

    case IMaxHouseYearChangedActionType:
      return {
        ...state,
        filters: {
          ...state.filters,
          jsonQuery: {
            ...state.filters.jsonQuery,
            house_year:
              action.value !== undefined || (house_year && house_year.value.gte !== undefined)
                ? {
                    type: 'range',
                    value: {
                      gte: house_year && house_year.value.gte,
                      lte: action.value,
                    },
                  }
                : undefined,
          },
        },
      };

    case 'filters/tags/TAG_REMOVED':
      if (action.tag.type === 'advanced-houseYear') {
        return {
          ...state,
          filters: {
            ...state.filters,
            jsonQuery: {
              ...state.filters.jsonQuery,
              house_year: undefined,
            },
          },
        };
      }

      return state;

    default:
      return state;
  }
}
